import { M as MobileModeHint } from './MobileModeHint-af8b89c1.js';

/* Utility for getting `matchMedia()` compatible function with or without a browser context */

function stubMatchMediaMobile() {
  return {
    matches: true,
    addListener: () => undefined,
    removeListener: () => undefined
  };
}
function stubMatchMediaNotMobile() {
  return {
    matches: false,
    addListener: () => undefined,
    removeListener: () => undefined
  };
}
function getMatchMediaFunction(hint) {
  if (typeof window !== 'undefined' && 'matchMedia' in window) {
    return window.matchMedia;
  }
  return hint === MobileModeHint.Mobile ? stubMatchMediaMobile : stubMatchMediaNotMobile;
}

export { getMatchMediaFunction as g };
//# sourceMappingURL=getMatchMediaFunction-6361be45.js.map
